<template>
    <TransitionRoot appear :show="show" as="template">
        <Dialog as="div" @close="$emit('close')" class="relative z-10">
            <TransitionChild
                as="template"
                enter="duration-300 ease-out"
                enter-from="opacity-0"
                enter-to="opacity-100"
                leave="duration-200 ease-in"
                leave-from="opacity-100"
                leave-to="opacity-0"
            >
                <div class="fixed inset-0 bg-black bg-opacity-25" />
            </TransitionChild>

            <div class="fixed inset-0 overflow-y-auto">
                <div class="flex min-h-full items-center justify-center p-4 text-center">
                    <TransitionChild
                        class="reschedule-modal"
                        as="template"
                        enter="duration-300 ease-out"
                        enter-from="opacity-0 scale-95"
                        enter-to="opacity-100 scale-100"
                        leave="duration-200 ease-in"
                        leave-from="opacity-100 scale-100"
                        leave-to="opacity-0 scale-95"
                    >
                        <DialogPanel
                        :class="width"
                        class="transform rounded-lg bg-white py-5 px-7 align-middle transition-all"
                        >
                            <div class="flex space-x-3 mb-5">
                                <div class="w-12 h-12 rounded-full bg-gray-200 flex justify-center items-center flex-shrink-0">
                                    <ExclamationCircleIcon class="w-5 h-5 text-gray-900 mx-auto"/>
                                </div>
                                <div class="w-full text-left">
                                    <DialogTitle
                                        as="p"
                                        class="font-bold text-lg text-gray-900"
                                    >
                                        {{ title }}
                                    </DialogTitle>
                                    <p class="text-sm text-gray-500">{{ content }}</p>
                                </div>
                            </div>

                            <div>
                                <slot name="fields"/>
                            </div>

                            <div class="mt-6 flex space-x-2 justify-end">
                                <button-component
                                v-if="cancelText"
                                secondary
                                @click="$emit('cancel')"
                                :disabled="disabledButton"
                                >{{ cancelText }}</button-component>
                                <button-component
                                v-if="actionText"
                                color="bg-gray-900 border-gray-900"
                                @click="$emit('confirm')"
                                :disabled="disabledButton"
                                >{{ actionText }}</button-component>
                            </div>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>

<script setup lang="ts">
import {
  TransitionRoot,
  TransitionChild,
  Dialog,
  DialogPanel,
  DialogTitle,
} from '@headlessui/vue'
import ButtonComponent from '@/components/ButtonComponent.vue';
import { ExclamationCircleIcon } from '@heroicons/vue/24/solid'

defineProps({
    show: {
        type: Boolean
    },
    title: {
        type: String,
    },
    content: {
        type: String,
    },
    actionText: {
        type: String,
    },
    cancelText: {
        type: String,
    },
    width: {
        type: String,
    },
    checkIcon: {
        type: Boolean,
        default: false
    },
    disabledButton: {
        type: Boolean,
        default: false
    }
})
</script>
<style lang="scss">
    .reschedule-modal {
        overflow: visible !important;
    }
</style>